// This file configures the initialization of Sentry on the client.
// The added config here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/career/:tenant/:path*?\",\"regex\":\"^/career/([^/]+)(?:/(.*))?$\",\"paramNames\":[\"tenant\",\"path\"],\"hasOptionalPrefix\":false}],\"staticRoutes\":[],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.4.2";globalThis["_sentryRewritesTunnelPath"] = "/career/monitoring";import * as Sentry from '@sentry/nextjs'
import { z } from 'zod'

//Disable Zod Jit compiler to avoid CSP 'unsafe-eval' violations
z.config({ jitless: true })

Sentry.init({
  enabled: !!process.env.SENTRY_DSN,
  dsn: process.env.SENTRY_DSN,
  environment: process.env.SENTRY_ENVIRONMENT,
  integrations: [Sentry.replayIntegration()],
  tracesSampleRate: process.env.SENTRY_TRACES_SAMPLE_RATE ? parseFloat(process.env.SENTRY_TRACES_SAMPLE_RATE) : 0.1,
  enableLogs: true,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  sendDefaultPii: true
})

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart
